export default __webpack_public_path__ + "assets/images/6ecbcdc31519431a286980a52448a46b.svg";